export default __webpack_public_path__ + "static/promote-1-cd7cccc9f6a11ff4bfd09bc021aaee92.png";